import type { Theme } from '../../types/theme';

export const sanityTheme: Theme = {
  id: 'sanity',
  name: 'Sanity',
  description: 'Dark studio aesthetic with bold red accent for content platform',
  sourceDesignMd: 'https://github.com/nexu-io/open-design/blob/main/design-systems/sanity/DESIGN.md',
  visualKeywords: ['dark', 'red accent', 'studio CMS', 'customizable', 'content-first'],
  colors: {
    background: '#0a0a0a',
    surface: '#1a1a1a',
    surfaceElevated: '#242424',
    textPrimary: '#ffffff',
    textSecondary: '#a3a3a3',
    textMuted: '#a3a3a3',
    border: '#2a2a2a',
    borderSubtle: '#343434',
    primary: '#f43a5e',
    primaryHover: '#e0264a',
    primaryActive: '#d61c40',
    accent: '#f43a5e',
    onPrimary: '#ffffff',
    success: '#22c55e',
    warning: '#f59e0b',
    error: '#ef4444',
  },
  typography: {
    headingFont: 'Inter, system-ui, sans-serif',
    bodyFont: 'Inter, system-ui, sans-serif',
    monoFont: 'JetBrains Mono, monospace',
    headingWeight: '600',
    bodyWeight: '400',
    letterSpacingHeading: '-0.02em',
    letterSpacingBody: '0',
  },
  radius: {
    button: '6px',
    card: '8px',
    panel: '8px',
    badge: '4px',
    input: '6px',
  },
  shadow: {
    card: '0 1px 3px rgba(0,0,0,0.1)',
    elevated: '0 4px 12px rgba(0,0,0,0.15)',
    button: '0 1px 2px rgba(0,0,0,0.1)',
    none: 'none',
  },
  layout: {
    maxWidth: '1280px',
    sectionSpacing: '80px',
    cardPadding: '24px',
    navHeight: '64px',
  },
  mood: {
    density: 'medium',
    tone: 'creative',
    productFit: [],
    bestFor: [],
    notGoodFor: [],
  },
};
